"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpansionPanel = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _icons = require("../../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    expansionDetails: {
      padding: '0'
    },
    dropDown: {
      color: theme.palette.primary.main
    }
  };
});

var ExpansionPanel = function ExpansionPanel(_ref) {
  var title = _ref.title,
      children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.ExpansionPanel, null, /*#__PURE__*/_react["default"].createElement(_core.ExpansionPanelSummary, {
    expandIcon: /*#__PURE__*/_react["default"].createElement(_icons.DropDown, {
      className: classes.dropDown
    }),
    "aria-controls": "".concat(title, "-content"),
    id: "".concat(title, "-header")
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1"
  }, title)), /*#__PURE__*/_react["default"].createElement(_core.ExpansionPanelDetails, {
    className: classes.expansionDetails
  }, children));
};

exports.ExpansionPanel = ExpansionPanel;